import React from 'react';
import PostInvoicePage from './PostInvoicePage';

const PostInvoiceTenantPage = () => <PostInvoicePage isOwner={false}/>;

export default PostInvoiceTenantPage;
